export const errorLangMappings = {
    "C1052": {
        "en" : "This email address already exists",
        "pl" : "Istnieje konto powiązane z tym adresem e-mail.",
        "bn" : "এই ইমেল অ্যাড্রেস ইতিমধ্যে বিদ্যমান রয়েছে।",
        "zh" : "该电子邮件地址已存在",
        "fr" : "Désolé, cette adresse électronique existe déjà.",
        "de" : "Diese E-Mail-Adresse gibt es bereits.",
        "hi" : "यह ईमेल पता पहले से मौजूद है.",
        "id" : "Alamat email ini sudah ada",
        "ru" : "Этот адрес электронной почты уже существует",
        "th" : "มีที่อยู่อีเมลนี้อยู่แล้ว",
        "tr" : "Bu e-posta adresi zaten var",
        "vi" : "Địa chỉ email này đã tồn tại",
        "it": "L'indirizzo e-mail immesso è già presente nel sistema.",
        "ar" : "يجب أن يكون عنوان بريدك الإلكتروني مختلفًا عن ذلك في ملفك الشخصي الحالي.",
    },
    "C1070": {
        "en" : "We're sorry, but there was a problem completing your registration. Please try again.",
        "pl": "Przepraszamy, ale wystąpił problem i nie można było zakończyć rejestracji.",
        "bn" : "আপনার রেজিস্ট্রেশন সম্পূর্ণ করার সময় সমস্যা হয়েছে।",
        "zh": "抱歉，完成注册时出现问题。",
        "fr": "Désolé, nous avons rencontré un problème lors de votre inscription.",
        "de": "Bei Ihrer Registrierung ist leider ein Problem aufgetreten.",
        "hi" : "हमें खेद है, आपका रजिस्ट्रेशन पूरा करने में कोई समस्या हुई.",
        "id" : "Maaf, ada masalah saat menyelesaikan pendaftaran Anda.",
        "ru" : "Извините, при завершении регистрации возникла проблема.",
        "th" : "ขออภัย มีปัญหาเกิดขึ้นในการลงทะเบียนของคุณ",
        "it" : "Siamo spiacenti, si è verificato un problema durante il completamento della registrazione.",
        "vi" : "Rất tiếc, đã xảy ra sự cố và không thể hoàn tất yêu cầu của bạn.",
        "tr" : "Maalesef kaydınız tamamlanırken bir sorun oluştu.",
        "ar" : "عذرًا، لكن حدثت مشكلة تقنية." // to confirm
    },
    "C5001" : {
        "en": "Please complete all mandatory fields and re-submit your request.",
        "it": "Compila tutti i campi obbligatori e invia nuovamente la richiesta.",
        "vi": "Vui lòng điền tất cả các trường bắt buộc và gửi lại yêu cầu của bạn.",
        "ar": "يرجى إكمال جميع الحقول الإجبارية وإعادة إرسال الطلب.",
        "th": "กรุณากรอกข้อมูลในช่องบังคับทั้งหมดแล้วส่งคำขอของคุณใหม่",
        "tr": "Lütfen tüm zorunlu alanları doldurup isteğinizi tekrar gönderin.",
        "ru": "कृपया सभी अनिवार्य क्षेत्रों को पूरा भर कर अपना अनुरोध फिर से सबमिट करें.",
        "id": "Silakan isi bidang yang wajib diisi, lalu kirimkan ulang permintaan Anda.",
        "hi": "कृपया सभी अनिवार्य क्षेत्रों को पूरा भर कर अपना अनुरोध फिर से सबमिट करें।",
        "de": "Bitte füllen Sie alle Pflichtfelder aus und senden Sie Ihre Anfrage erneut.",
        "fr": "Veuillez compléter tous les champs obligatoires et envoyer à nouveau votre demande.",
        "zh": "请完成所有必填字段，并重新提交您的申请。",
        "bn": "সব আবশ্যকীয় ফিল্ড পূরণ করে আবার আপনার অনুরোধ জমা দিন।",
        "pl": "Wypełnij wszystkie pola obowiązkowe i prześlij ponownie żądanie."
    },
    "other": {
        "en": "We're sorry, but there's been a technical problem.",
        "bn": "আমরা দুঃখিত, কিন্তু কোনো টেকনিকাল সমস্যা হয়েছে।",
        "pl": "Przepraszamy, ale wystąpił problem techniczny.",
        "zh": "抱歉，出现技术问题。",
        "fr": "Désolé, un problème technique est survenu.",
        "de": "Leider ist ein technisches Problem aufgetreten.",
        "hi": "हमें खेद है, लेकिन कोई तकनीकी समस्या हुई है.",
        "id": "Maaf, sepertinya ada masalah teknis.",
        "ru": "К сожалению, возникла техническая проблема.",
        "ar": "عذرًا، لكن حدثت مشكلة تقنية.",
        "th": "ขออภัย เกิดข้อผิดพลาดทางเทคนิค",
        "tr": "Üzgünüz, teknik bir hata oluştu.",
        "it": "Siamo spiacenti, si è verificato un problema tecnico.",
        "vi": "Chúng tôi rất tiếc, nhưng đã xảy ra lỗi kỹ thuật."
    }
}